import { createContext } from 'react';

const AuthContext = createContext({
    isAuthenticated: false,
    user: null,
    login: () => Promise.resolve(),
    signup: () => Promise.resolve(),
    refreshProfile: () => Promise.resolve(),
    logout: () => { },
    isLoading: false,
    refreshUser: () => Promise.resolve(), // Add this new function
    canManageTenantUsers: (tenantId) => false
});

export default AuthContext;